<template>
  <div>
    <top :title="title"></top>

    <!-- 纯原生搜索区域：关键词输入 + 原生状态筛选下拉 -->
    <div class="search-box" v-if="showSearch">
      <!-- 订单号/款号搜索框 -->
      <div class="search-input">
        <input
          type="search"
          v-model="keywords"
          :placeholder="searchPlaceholder"
          @keyup.enter="handleSearch"
          @search="handleSearch"
          inputmode="search"
        />
        <div class="search-btn" @click="handleSearch">
          <i class="el-icon-search"></i>
        </div>
        <!-- 扫码按钮 -->
        <div class="scan-btn" v-if="this.type == 'laser'" @click="openScanner">
          <i class="el-icon-camera"></i>
        </div>
        <!-- 原生订单状态筛选下拉框（仅订单列表显示） -->
        <div class="status-select" v-if="type == 'order' || type == 'laser'">
          <div class="select-wrap" @click="toggleStatusDropdown">
            <span class="select-text">{{ selectedStatusText }}</span>
            <i class="arrow-icon" :class="{ active: statusDropdownShow }"></i>
          </div>
          <!-- 下拉选项列表 -->
          <div class="select-dropdown" v-show="statusDropdownShow">
            <div
              class="dropdown-item"
              v-for="item in statusList"
              :key="item.type"
              :class="{ active: statusValue === item.type }"
              @click="selectStatus(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 二维码扫描弹窗 -->
    <div v-if="showScanner" class="scanner-modal">
      <div class="scanner-header">
        <div class="scanner-title">扫码</div>
        <div class="close-btn" @click="closeScanner">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="scanner-content">
        <!-- 摄像头视频流 -->
        <video
          ref="videoRef"
          class="scanner-video"
          autoplay
          playsinline
        ></video>
        <!-- 扫描框 -->
        <div class="scan-frame">
          <div class="frame-corner top-left"></div>
          <div class="frame-corner top-right"></div>
          <div class="frame-corner bottom-left"></div>
          <div class="frame-corner bottom-right"></div>
          <div class="scan-line" :style="scanLineStyle"></div>
        </div>
        <div class="scan-tip">将二维码放入框内，即可自动扫描</div>
      </div>
      <div class="scanner-footer">
        <div class="scanner-btn cancel-btn" @click="closeScanner">取消</div>
        <div class="scanner-btn light-btn" @click="toggleLight">
          {{ isLightOn ? '关闭闪光灯' : '打开闪光灯' }}
        </div>
      </div>
    </div>
    <!-- 蒙层 -->
    <div v-if="showScanner" class="modal-mask"></div>

    <div class="order-con" :class="{ 'with-search': showSearch }">
      <div class="order-item" v-for="(item, index) in orderList" :key="index">
        <div class="title flex ali-cen jusc-be">
          <div>No:{{ item.orderNumber }}</div>
          <div class="status">{{ getStatus(item.processStatus) }}</div>
        </div>
        <div class="oder-info">
          <image-preview
            class="good-img"
            :src="item.img"
            :width="62"
            :height="62"
          />
          <div class="infos">
            <div class="flex jusc-be">
              <div class="style">款号：{{ item.styleCode }}</div>
              <div class="num">x{{ getQuantity(item) }}</div>
            </div>
            <div class="time">{{ item.orderDate }}</div>
          </div>
        </div>
        <div class="btn-box">
          <div class="use-btn" @click="goDetails(item, null)">详情</div>
          <div
            class="use-btn"
            v-if="type == 'print'"
            @click="goDetails(item, null)"
          >
            打纸
          </div>
          <div
            class="use-btn"
            v-if="type == 'machines'"
            @click="goDetails(item, null)"
          >
            转印
          </div>
          <div
            class="use-btn"
            v-if="type == 'laser'"
            @click="goDetails(item, 1)"
          >
            激光加工
          </div>
          <div
            class="use-btn"
            v-if="type == 'producing'"
            @click="goDetails(item, 1)"
          >
            制衣出货
          </div>
          <div
            class="use-btn"
            v-if="type == 'producing'"
            @click="goDetails(item, 2)"
          >
            车位加工
          </div>
        </div>
      </div>

      <!-- 无搜索结果提示 -->
      <div class="empty-tip" v-if="orderList.length === 0">
        <p>暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import {
  getOrderPage,
  pageClothingOrder,
  pageClothingFactoryAssign,
  deptPageClothingFactoryAssign,
  paperOrder,
  transferOrder,
} from "@/http/index";

export default {
  components: {
    top,
  },
  data() {
    return {
      // 扫码相关
      showScanner: false,
      videoStream: null,
      scanInterval: null,
      isLightOn: false,
      scanLinePosition: 0,
      scanDirection: 1,
      orderList: [],
      title: "",
      type: "",
      keywords: "",
      showSearch: true,
      // 状态筛选相关
      statusValue: "", // 选中的状态值
      statusDropdownShow: false, // 下拉菜单显示状态
      statusList: [
        { type: "", name: "全部状态" },
        { type: 1, name: "已打单" },
        { type: 2, name: "已打纸" },
        { type: 3, name: "已转印" },
        { type: 4, name: "已激光" },
        { type: 5, name: "制衣生产" },
        { type: 6, name: "制衣部分" },
        { type: 7, name: "制衣全部" },
      ],
    };
  },
  computed: {
    scanLineStyle() {
      return {
        top: `${this.scanLinePosition}%`,
        transition: this.scanLinePosition === 0 || this.scanLinePosition === 100 ? 'none' : 'top 0.1s linear'
      };
    },
    searchPlaceholder() {
      const placeholders = {
        order: "搜索订单号/款号",
        orderList: "搜索款号",
      };
      return placeholders[this.type] || "请输入关键词搜索";
    },
    // 计算选中的状态文本
    selectedStatusText() {
      const selected = this.statusList.find(
        (item) => item.type === this.statusValue,
      );
      return selected ? selected.name : "全部状态";
    },
  },
  created() {
    this.type = this.$route.query.type;
    if (this.type != "orderList") {
      this.getList();
    } else {
      this.title = "款号查询";
    }
    // 监听点击空白处关闭下拉
    document.addEventListener("click", this.handleDocumentClick);
  },
  destroyed() {
    // 移除事件监听，避免内存泄漏
    document.removeEventListener("click", this.handleDocumentClick);
    this.closeScanner();
  },
  methods: {
    // 打开扫码界面
      async openScanner() {
        try {
          this.showScanner = true;
          await this.$nextTick();

          // 请求摄像头权限
          const stream = await navigator.mediaDevices.getUserMedia({
            video: {
              facingMode: 'environment',
              width: { ideal: 1280 },
              height: { ideal: 720 }
            }
          });

          this.videoStream = stream;
          const video = this.$refs.videoRef;
          video.srcObject = stream;

          // 等待视频开始播放
          await new Promise((resolve) => {
            video.onloadedmetadata = () => {
              video.play().then(resolve);
            };
          });

          // 开始扫描动画
          this.startScanAnimation();

          // 开始扫描二维码
          this.startQRScanning();

        } catch (error) {
          console.error('摄像头访问失败:', error);
          this.$message.error('无法访问摄像头，请确保已授予权限');
          this.closeScanner();
        }
      },

      // 开始扫描动画
      startScanAnimation() {
        this.scanInterval = setInterval(() => {
          if (this.scanLinePosition >= 100) {
            this.scanDirection = -1;
          } else if (this.scanLinePosition <= 0) {
            this.scanDirection = 1;
          }
          this.scanLinePosition += this.scanDirection * 2;
        }, 50);
      },

      // 开始扫描二维码
      async startQRScanning() {
        // 动态导入jsqr库，避免打包问题
        const jsQR = await import('jsqr').then(module => module.default || module);

        const scan = () => {
          if (!this.showScanner) return;

          const video = this.$refs.videoRef;
          if (video.readyState === video.HAVE_ENOUGH_DATA) {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');

            // 设置canvas尺寸与视频一致
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            // 绘制当前视频帧到canvas
            context.drawImage(video, 0, 0, canvas.width, canvas.height);

            // 获取图像数据
            const imageData = context.getImageData(0, 0, canvas.width, canvas.height);

            // 使用jsQR扫描二维码
            const code = jsQR(imageData.data, canvas.width, canvas.height, {
              inversionAttempts: 'dontInvert',
            });

            // 如果扫描到二维码
            if (code) {
              this.handleScanResult(code.data);
            }
          }

          // 继续下一帧扫描
          requestAnimationFrame(scan);
        };

        requestAnimationFrame(scan);
      },

      // 处理扫描结果
      handleScanResult(result) {
        console.log('扫描结果:', result);
        // 关闭扫描器
        this.closeScanner();
        this.$router.push({
          path: "/laserAdd",
          query: { id: result, orderId: result },
        });
      },

      // 关闭扫码界面
      closeScanner() {
        this.showScanner = false;
        // 停止扫描动画
        if (this.scanInterval) {
          clearInterval(this.scanInterval);
          this.scanInterval = null;
        }
        // 停止摄像头
        if (this.videoStream) {
          this.videoStream.getTracks().forEach(track => track.stop());
          this.videoStream = null;
        }
        // 重置扫描线位置
        this.scanLinePosition = 0;
      },
      // 切换闪光灯
      toggleLight() {
        if (!this.videoStream) return;
        const videoTrack = this.videoStream.getVideoTracks()[0];
        if (videoTrack && typeof videoTrack.getCapabilities === 'function') {
          const capabilities = videoTrack.getCapabilities();
          if (capabilities.torch) {
            this.isLightOn = !this.isLightOn;
            videoTrack.applyConstraints({
              advanced: [{ torch: this.isLightOn }]
            }).catch(error => {
              console.error('闪光灯控制失败:', error);
              this.isLightOn = false;
            });
          } else {
            this.$message.warning('当前设备不支持闪光灯');
          }
        }
      },
    getQuantity(item) {
        switch(this.type) {
            case 'deptProducing':
            case 'producing':
                return item.orderTotalNum;
            default: return item.number;
        }
    },
    getStatus(e) {
      const status = this.statusList.find((item) => item.type == e);
      return status ? status.name : "";
    },

    // 切换状态下拉菜单显示/隐藏
    toggleStatusDropdown(e) {
      e.stopPropagation(); // 阻止事件冒泡
      this.statusDropdownShow = !this.statusDropdownShow;
    },

    // 选择状态选项
    selectStatus(item) {
      this.statusValue = item.type;
      this.statusDropdownShow = false; // 选择后关闭下拉
      this.handleSearch(); // 触发搜索
    },

    // 点击空白处关闭下拉菜单
    handleDocumentClick() {
      this.statusDropdownShow = false;
    },

    getList() {
      // 统一请求参数
      const requestParams = {
        pageNum: 1,
        pageSize: 1000,
        keywords: this.keywords,
      };

      // 订单列表新增状态筛选参数
      if (this.statusValue !== "") {
        requestParams.processStatus = this.statusValue;
      }
      this.title = "订单列表";
      console.log(this.title);
      if (this.type == "print") {
        requestParams.processStatus = 1;
        this.title = "打印室";
      } else if (this.type == "machines") {
        requestParams.processStatus = 2;
        this.title = "大机";
      } else if (this.type == "laser") {
        requestParams.processCondition = 2;
        this.title = "激光";
      } else if (this.type == "orderList") {
        requestParams.keywords = "";
        requestParams.styleCode = this.keywords;
        this.title = "款号查询";
      }

      if (this.type == "clothingOrder") {
        pageClothingOrder(requestParams).then((res) => {
          this.orderList = res.rows;
        });
      } else if (this.type == "producing") {
        this.title = "生产中";
        pageClothingFactoryAssign(requestParams).then((res) => {
          this.orderList = res.rows;
        });
      } else if (this.type == "deptProducing") {
        this.title = "生产中";
        deptPageClothingFactoryAssign(requestParams).then((res) => {
          this.orderList = res.rows;
        });
      } else {
        getOrderPage(requestParams).then((res) => {
          this.orderList = res.rows;
        });
      }
    },

    handleSearch() {
      // 清空列表后重新请求，提升体验
      this.orderList = [];
      this.getList();
    },

    goDetails(data, producingType) {
      if (this.type == "print") {
        paperOrder([data.id]).then((res) => {
          this.getList();
        });
      } else if (this.type == "machines") {
        transferOrder([data.id]).then((res) => {
          this.getList();
        });
      } else if (this.type == "laser") {
        if (producingType == 1) {
          this.$router.push({
            path: "/laserAdd",
            query: { id: data.id, orderId: data.id },
          });
        } else {
          this.$router.push({ path: "/orderDeatils", query: { id: data.id } });
        }
      } else if (this.type == "producing") {
        if (producingType == 1) {
          this.$router.push({
            path: "/shipmentAdd",
            query: { id: data.id, orderId: data.orderId },
          });
        } else {
          this.$router.push({
            path: "/processingAdd",
            query: { id: data.id, orderId: data.orderId },
          });
        }
      } else {
        this.$router.push({ path: "/orderDeatils", query: { id: data.id } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* 纯原生搜索区域样式 */
.search-box {
  padding: 12px 24px 0;
  background-color: #f7f8fa;
  display: flex;
  flex-direction: column;
  gap: 10px; /* 输入框和筛选框间距 */

  .search-input {
    position: relative;
    display: flex;
    align-items: center;

    input {
      flex: 1;
      height: 36px;
      padding: 0 20px 0 40px; /* 增加右侧padding给两个按钮留空间 */
      border: 1px solid #e4e7ed;
      border-radius: 18px;
      background-color: #fff;
      font-size: 14px;
      color: #303133;

      &:focus {
        outline: none;
        border-color: #e44338;
      }

      &::placeholder {
        color: #c0c4cc;
      }
    }

    .search-btn {
      position: absolute;
      left: 12px;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #909399;
    }

    /* 扫码按钮样式 */
    .scan-btn {
      position: absolute;
      right: 120px;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #e44338;
      font-size: 18px;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  /* 原生状态筛选样式 */
  .status-select {
    width: 100%;
    position: relative;

    .select-wrap {
      width: 100%;
      height: 36px;
      border: 1px solid #e4e7ed;
      border-radius: 18px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px;
      font-size: 14px;
      color: #303133;
      cursor: pointer;

      .select-text {
        flex: 1;
        text-align: left;
      }

      .arrow-icon {
        width: 12px;
        height: 12px;
        border: solid #909399;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        transition: transform 0.2s ease;

        &.active {
          transform: rotate(-135deg);
          margin-top: 5px;
        }
      }
    }

    .select-dropdown {
      position: absolute;
      top: 42px;
      left: 0;
      right: 0;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      z-index: 999;
      max-height: 200px;
      overflow-y: auto;

      .dropdown-item {
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        font-size: 14px;
        color: #303133;
        cursor: pointer;

        &:hover {
          background-color: #f5f7fa;
        }

        &.active {
          color: #e44338;
          font-weight: 500;
          background-color: #fef0f0;
        }
      }
    }
  }
}


/* 扫码弹窗样式 */
.scanner-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 400px;
  background: #000;
  border-radius: 12px;
  z-index: 1001;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);

  .scanner-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background: rgba(0, 0, 0, 0.8);

    .scanner-title {
      font-size: 18px;
      font-weight: 600;
      color: #fff;
    }

    .close-btn {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #fff;
      font-size: 20px;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .scanner-content {
    position: relative;
    padding: 20px;

    .scanner-video {
      width: 100%;
      height: 300px;
      object-fit: cover;
      border-radius: 8px;
      background: #000;
    }

    .scan-frame {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 70%;
      height: 200px;
      border: 2px solid rgba(255, 255, 255, 0.3);
      border-radius: 8px;
      overflow: hidden;

      .frame-corner {
        position: absolute;
        width: 20px;
        height: 20px;
        border-color: #e44338;
        border-style: solid;

        &.top-left {
          top: 0;
          left: 0;
          border-width: 2px 0 0 2px;
          border-top-left-radius: 4px;
        }

        &.top-right {
          top: 0;
          right: 0;
          border-width: 2px 2px 0 0;
          border-top-right-radius: 4px;
        }

        &.bottom-left {
          bottom: 0;
          left: 0;
          border-width: 0 0 2px 2px;
          border-bottom-left-radius: 4px;
        }

        &.bottom-right {
          bottom: 0;
          right: 0;
          border-width: 0 2px 2px 0;
          border-bottom-right-radius: 4px;
        }
      }

      .scan-line {
        position: absolute;
        left: 0;
        width: 100%;
        height: 2px;
        background: linear-gradient(90deg, transparent, #e44338, transparent);
        box-shadow: 0 0 10px #e44338;
      }
    }

    .scan-tip {
      text-align: center;
      color: #fff;
      margin-top: 20px;
      font-size: 14px;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    }
  }

  .scanner-footer {
    display: flex;
    padding: 16px 20px;
    background: rgba(0, 0, 0, 0.8);
    gap: 10px;

    .scanner-btn {
      flex: 1;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s;

      &.cancel-btn {
        background: rgba(255, 255, 255, 0.1);
        color: #fff;
        border: 1px solid rgba(255, 255, 255, 0.3);

        &:hover {
          background: rgba(255, 255, 255, 0.2);
        }
      }

      &.light-btn {
        background: #e44338;
        color: #fff;

        &:hover {
          background: #d33a30;
        }
      }
    }
  }
}

/* 蒙层 */
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}

.order-con {
  background-color: #f7f8fa;
  padding: 24px;
  height: 100vh;

  &.with-search {
    padding-top: 12px;
  }

  .order-item {
    background: #ffffff;
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 12px;

    .title {
      font-size: 14px;
      color: #303133;
      margin-bottom: 16px;
      font-weight: bold;
    }

    .status {
      font-weight: 600;
      font-size: 14px;
      color: #e44338;
    }

    .oder-info {
      display: flex;
      align-items: center;

      .good-img {
        width: 90px;
        height: 62px;
        border-radius: 4px;
        margin-right: 10px;
      }

      .infos {
        flex: 1;
      }

      .style {
        font-weight: 500;
        font-size: 14px;
        color: #303133;
      }

      .num {
        text-align: right;
        font-weight: 500;
        font-size: 14px;
        color: #909399;
      }

      .time {
        font-weight: 400;
        font-size: 13px;
        color: #303133;
        margin-top: 10px;
      }
    }

    .btn-box {
      display: flex;
      justify-content: flex-end;
      margin-top: 16px;

      .use-btn {
        margin-right: 4px;
        padding: 4px 12px;
        background: #ffffff;
        border-radius: 30px;
        border: 1px solid #e24a41;
        font-weight: 600;
        font-size: 14px;
        color: #e44338;
        cursor: pointer;
      }
    }
  }

  /* 无搜索结果提示 */
  .empty-tip {
    text-align: center;
    padding: 60px 20px;

    p {
      color: #909399;
      font-size: 14px;
    }
  }
}

/* 辅助布局样式 */
.flex {
  display: flex;
}
.ali-cen {
  align-items: center;
}
.jusc-be {
  justify-content: space-between;
}
</style>
